import API from "../../../helpers/devApi";

const API_ENDPOINTS = "/ade_deleg_event";
// const TEST_API_ENDPOINTS = "http://localhost:6006/api/v1"

// Create  new Requisiton
export function createAssignTemplate(payload) {
  return API.post(API_ENDPOINTS, payload);
}

export function getAllConfigList() {
  return API.get(`${API_ENDPOINTS}`);
}

export function getAllCardList() {
  return API.get(`${API_ENDPOINTS}/getCards/own`);
}

export function getConfigDetails(id) {
  return API.get(`${API_ENDPOINTS}/${id}`);
}

export function updateAssignTemplate(id, payload) {
  return API.patch(`${API_ENDPOINTS}/${id}`, payload);
}

export function deleteAssignTemplate(id) {
  return API.delete(`${API_ENDPOINTS}/${id}`);
}

export function getAllApproverList() {
  return API.get(`/ade_deleg_approval_type`);
}

export function getAllTableList() {
  return API.get(`/ade_tables`);
}

export function getColumnListByTableName(payload) {
  return API.post(`/ade_tables/get_table_field`, payload);
}

export function getApprovalHistoryInfo(payload) {
  return API.post(
    `/ade_deleg_delegation_tracking/getMyAll/Tracking/Histort`,
    payload
  );
}

export function getApprovalHistoryOfATargetActionId(
  event_id,
  target_action_id,
  query
) {
  return API.get(
    // `${TEST_API_ENDPOINTS}/ade_deleg_delegation_tracking/history/${event_id}/${target_action_id}`,
    `/ade_deleg_delegation_tracking/history/${event_id}/${target_action_id}`,
    {
      params: query,
    }
  );
}

export function getPendingDelegationCurrentResposibles(payload) {
  return API.post(`ade_deleg_delegation_tracking/tracking-history`, payload);
}
